import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../Assets/png/satalite.png";

export const Contact = () => {
  // const formInitialDetails = {
  //   firstName: '',
  //   lastName: '',
  //   email: '',
  //   phone: '',
  //   message: ''
  // }
  // const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  // const [status, setStatus] = useState({});

  // const onFormUpdate = (category, value) => {
  //   setFormDetails({
  //     ...formDetails,
  //     [category]: value
  //   })
  // }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    //setButtonText("Sending...");
    // let response = await fetch("", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json;charset=utf-8",
    //   },
    //   body: JSON.stringify(formDetails),
    // });
    //setButtonText("Sent");
    // let result = await response.json();
    // setFormDetails(formInitialDetails);
    // if (result.code === 200) {
    //   setStatus({ success: true, message: 'Message sent successfully' });
    // } else {
    //   setButtonText("failed :(");
    //   setStatus({ success: false, message: 'Something went wrong, please try again later.' });
    // }
  //};

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
        <Col size={12} md={6} className="satellite-container">
        <a href="https://instagram.com/adnan_shelim?igshid=YmMyMTA2M2Y="><img src={contactImg} alt="Contact Us" className="satellite" /></a>
          </Col>
          <Col size={12} md={6}>
            <div>
              <h2>Get In Touch</h2>
              <form name="contact" method="post" netlify-data="true" netlify-honeypot="bot-field">
              <input type="hidden" name="form-name" value="contact"/>
              <div hidden><input type="hidden" name="bot-field"/></div>
                <Row>
                  <Col size={12} sm={6} className="px-1">
                    <input type="text" name="firstname" id="firstname" required placeholder="First Name" />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="text" name="lastname" id="lastname" placeholder="Last Name"  />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="email" name="email" id="email" required placeholder="Email Address"/>
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="tel" name="tel" id="tel" placeholder="Phone No." />
                  </Col>
                  <Col size={12} className="px-1">
                    <textarea rows="6" name="message" id="message" required placeholder="Message"></textarea>
                    <button type="submit" onClick={()=> setButtonText("Sent")}><span>{buttonText}</span></button>
                  </Col>
                  {/* {
                    status.message &&
                    <Col>
                      <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                    </Col>
                  } */}
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}